import React, { Component } from 'react'
import getFileIcon from '../../utils/getFileIcon'

class TaskFiles extends Component {
  handleDownloadFile = file => () => {
    const { download, type, row } = this.props
    download(file.file, row.sheid, row.instance, type)
  }

  renderFile = (file, index) => {
    return (
      <tr key={index}>
        <td className='td-center' width='20%'>
          <img alt={'icon'} src={getFileIcon(file.url ? 'url' : file.file)} />
        </td>
        <td width='80%'>
          {
            (file && file.url != null) ?
              <a href={file.url} className="fileLink" target="_blank">
                {file.file}
              </a>
              :
              <a role='button' onClick={this.handleDownloadFile(file)}>
                {file.file}
              </a>
          }
        </td>
      </tr>
    )
  }

  render() {
    const { handleCloseModal, modalData } = this.props
    return (
      <div className='tasks-files'>
        <div className='captions'>Файлы задания</div>
        <table>
          <tbody>{modalData?.map(this.renderFile)}</tbody>
        </table>
        <div className='buttons_panel'>
          <div className='left__panel'>&nbsp;</div>
          <div className='right__panel'>
            <a role='button' onClick={handleCloseModal}>
              Закрыть
            </a>
          </div>
        </div>
      </div>
    )
  }
}

export default TaskFiles
